export default "__VITE_PUBLIC_ASSET__370fa65a__"